import gql from 'graphql-tag';

import accountCardDetails from '../../../../cards/graphql/fragments/accountCardDetails';

export const getPurchasedCustomPrint = gql`
  query getPurchasedCustomPrint($purchased_custom_print_id: RecordID!) {
    purchasedCustomPrint(id: $purchased_custom_print_id) {
      id
      name
      account_card {
        account_card {
          ...accountCardDetails
        }
      }
    }
  }
  ${accountCardDetails}
`;
